/**
 * Central query-key factory. Every feature slice adds its namespace here so
 * cache invalidation stays greppable instead of scattered through components.
 *
 * Keys are tenant-scoped from the start. Without the tenant in the key, one
 * studio's cached data would be served to another the moment stage 6 puts
 * several studios behind the same bundle — a leak that surfaces late and
 * looks like a backend bug.
 */
export const queryKeys = {
  tenant: (tenantSlug: string) => ['tenant', tenantSlug] as const,
  services: (tenantSlug: string) => ['tenant', tenantSlug, 'services'] as const,
  service: (tenantSlug: string, serviceSlug: string) =>
    ['tenant', tenantSlug, 'services', serviceSlug] as const,
  workPhotos: (tenantSlug: string) => ['tenant', tenantSlug, 'work-photos'] as const,
  /** The signed-in client's bookings at this studio. */
  myBookings: (tenantSlug: string) => ['tenant', tenantSlug, 'my-bookings'] as const,
  /** Who is signed in on this device, if anyone. */
  clientSession: ['client-session'] as const,
  /** Not tenant-scoped: the token identifies the booking and its tenant. */
  bookingByToken: (token: string) => ['booking-by-token', token] as const,
} as const

export type QueryKeys = typeof queryKeys
